import Vue from "vue";
import Router from "vue-router";
import { apiClient } from "iv-base-components";
import moment from "moment-timezone";

Vue.use(Router);

var router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/booking",
      name: "booking",
      component: () => import("./views/Booking.vue")
    },
    {
      path: "/booking/mulgrave",
      name: "mulgrave",
      component: () => import("./views/Mulgrave.vue")
    },
    {
      path: "/booking/mulgrave-step-two",
      name: "mulgrave-step-two",
      component: () => import("./views/MulgraveStepTwo.vue")
    },
  ]
});

router.afterEach((to, from) => {
  // Report every page load
  // Notice this will not catch parameter or query changes
  // See https://router.vuejs.org/guide/advanced/navigation-guards.html
  try {
    // from.fullPath is NOT the correct path. it seems to be either null or
    // "/", which is not useful.
    console.log("Trying to contact rmal/page")
    //~ Vue.http.get("/api/rmal/page/", {params:{prev_page:from.fullPath, region:moment.tz.guess()}}).then(()=>{console.log("SUCCESS contacting rmal/page")}).catch((e)=>{console.error("Could not contact rmal/page",e)})
    //~ Vue.http.get(`/api/rmal/page/?prev_page=${from.fullPath}&region=somewhere`).then(()=>{console.log("SUCCESS contacting rmal/page")}).catch((e)=>{console.error("Could not contact rmal/page",e)})
    //~ Vue.http.get(`/api/rmal/page/?prev_page=${window.prev_page||"empty_route"}&region=somewhere`).then(()=>{console.log("SUCCESS contacting rmal/page")}).catch((e)=>{console.error("Could not contact rmal/page",e)})
    // This is unhappy on the server side, but oh well. It does work on the client side. In fact, I dont' want this to succeed on the server side.
    apiClient.get(`/api/rmal/page/?prev_page=${document.referrer||"empty_route"}&region=${moment.tz.guess()}`).then(()=>{console.log("SUCCESS contacting rmal/page")}).catch((e)=>{console.error("Could not contact rmal/page",e)})

  } catch (e){
    console.error("Could not contact rmal/page",e)
  }

  //~ console.log("fetching instead...")
  //~ fetch('/api/rmal/page/')
})

export default router